module.exports = __webpack_public_path__ + "static/media/ticket-pending-approval.5f5cffd0.svg";